"use client";
import {
  type Dispatch,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from "react";

export type TalkToSpecialistContext = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
};

const TalkToSpecialistContext = createContext<TalkToSpecialistContext>({
  open: false,
  setOpen: () => null,
});

export function TalkToSpecialistProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <TalkToSpecialistContext.Provider value={{ open, setOpen }}>
      {children}
    </TalkToSpecialistContext.Provider>
  );
}

export function useTalkToSpecialistContext() {
  const context = useContext(TalkToSpecialistContext);

  if (context === undefined) {
    throw new Error(
      "useTalkToSpecialistContext precisa estar dentro de TalkToSpecialistProvider",
    );
  }

  return useContext(TalkToSpecialistContext);
}
